module.exports = __webpack_public_path__ + "static/irvine-with-ice-cream.328652bc.jpg";